<div
  class="body-wrapper rtl"
  style="padding-top: 0; width: 500px; padding-right: 7em; padding-left: 2.5em"
>
  <div class="t-popup popup-patientDetails">
    <div class="t-popup-close"></div>

    <div class="t-popup-frame" style="width: 65em; max-width: fit-content">
      <div class="t-popup-body" [formGroup]="concentForm">
        <h2 style="direction: rtl">הסכמה מדעת</h2>

        <div
          id="concent"
          #concent
          class="m-box w100"
          style="direction: rtl; font-size: 12px; margin-left: 2em; margin-right: 2em"
        >
          <span>
            <h2
              *ngIf="
                concentForm.get('ExamType').value !== 'NT' &&
                concentForm.get('ExamType').value !== 'Third Scan'
              "
            >
              בדיקת אולטרה סאונד עוברי - - הצהרת הנבדקת
            </h2>
            <h2 *ngIf="concentForm.get('ExamType').value === 'NT'">
              בדיקה לשקיפות עורפית - - הצהרת הנבדקת
            </h2>
            <h2 *ngIf="concentForm.get('ExamType').value === 'Third Scan'">
              בדיקת התפתחות העובר בשליש השלישי - - הצהרת הנבדקת
            </h2>
          </span>
          <div style="direction: rtl; margin-bottom: 1em">
            <span *ngIf="concentForm.get('ExamType').value !== 'NT'">
              {{
                (concentForm.get('ExamType').value &&
                concentForm.get('ExamType').value !== 'NT' &&
                concentForm.get('ExamType').value !== 'Third Scan'
                  ? 'exam.type.OBS.' + concentForm.get('ExamType').value
                  : ''
                ) | translate
              }}
              -- היא בדיקת אולטרסאונד המתבצעת ע"י רופא העומד בדרישות משרד הבריאות לביצוע הבדיקה.
              מטרת הבדיקה הינה לבדוק את מבנה איברי הגוף של העובר בהתאם לפירוט שנקבע על ידי האיגוד
              הישראלי למיילדות וגינקולוגיה ומפורט בדו"ח הבדיקה. הבדיקה נעשית באמצעות מכשיר
              אולטרסאונד בגלי על קול. הבדיקה אינה מסוכנת לאם או לעובר. הבדיקה נעשית בגישה בטנית
              ובמידת הצורך גם בגישה לדנית.
            </span>

            <span *ngIf="concentForm.get('ExamType').value === 'NT'">
              {{ 'exam.type.OBS.' + concentForm.get('ExamType').value | translate }} -- בדיקת שקיפות
              עורפית הינה בדיקת אולטרסאונד המבוצעת באשה הרה לצורך הערכת הסיכון לתסמונת דאון
              (Syndrome Down (ולליקויים נוספים. על פי הנחיות משרד הבריאות שקיפות עורפית הינה בדיקת
              הסינון המומלצת לאיתור תסמונת דאון בהריונות יחיד ובהריונות מרובי עוברים כאחד. הבדיקה
              מבוצעת בין שבוע 11 ל- 13+6 (תואם גודל עובר של 45-84 מ"מ), בגישה בטנית או בגישה לדנית,
              בהתאם להחלטת הרופא המבצע. בבדיקה נמדד עובי הנוזל התת עורי בעורף העובר. שילוב בין ממצאי
              הבדיקה וסיכון הרקע הנגזר מגיל האם, מאפשר הערכת סיכון סטטיסטי לתסמונת דאון. בהריון עם
              עובר יחיד מומלץ לשלב את התוצאה עם סמנים ביוכימיים מדם האם. הובהר לי שבמידה ותמצא דרגת
              סיכון גבוהה לתסמונת דאון, אופנה ליעוץ גנטי לקביעת המלצות להמשך בירור. הבדיקה אינה
              יכולה לשלול תסמונת דאון או הפרעות כרומוזומליות אחרות באופן מוחלט. ניתן להגיע לאבחנה
              סופית של תסמונת דאון או הפרעות כרומוזומליות נוספות, רק באמצעות בדיקות פולשניות (דיקור
              מי שפיר או סיסי שליה). כן הובהר לי כי במקרה של שקיפות עורפית מעל 3 מ"מ, קיים סיכון
              מוגבר למומים נוספים, ולפיכך מימצא זה לכשעצמו מצדיק הפנייה ליעוץ גנטי, ולאקו לב עובר.
              הובהר לי שתוצאה המצביעה על רמת סיכון נמוכה אינה מבטלת המלצה לבדיקה פולשנית מסיבות
              אחרות. בכל מקרה יועץ גנטי הינו הגורם המוסמך ליעוץ, המלצה ולקביעת זכאות האישה לבדיקה
              פולשנית. עוד הובהר לי כי הבדיקה אינה מחליפה בדיקות אחרות, כמו בדיקות סקר גנטיות או
              חלבון עוברי כבדיקת סקירה למומים פתוחים במערכת העצבים. בדיקת שקיפות עורפית אינה סקירת
              מערכות. יש לפנות עם תוצאות הבדיקה לרופא המטפל
            </span>

            <span *ngIf="concentForm.get('ExamType').value === 'Third Scan'">
              {{ 'exam.type.OBS.' + concentForm.get('ExamType').value | translate }} -- בדיקת
              התפתחות העובר בשליש השלישי הינה הערכת התפתחות העובר הינה בדיקת אולטרסאונד המתבצעת ע"י
              רופא העומד בדרישות משרד הבריאות לביצוע הבדיקה. מטרת הבדיקה הינה לבדוק את התפתחות איברי
              הגוף של העובר, בהתאם לפירוט שנקבע על ידי האיגוד הישראלי למיילדות וגינקולוגיה ומפורט
              בדו''ח הבדיקה. הבדיקה נעשית באמצעות מכשיר אולטרה סאונד המשתמש בגלי על קול. הבדיקה אינה
              מסוכנת לאם או לעובר. הבדיקה נעשית בגישה בטנית ובמידת הצורך גם בגישה לדנית.
            </span>
          </div>
          <div>
            <span><strong>שם הנבדקת</strong></span>
          </div>
          <div style="display: flex; margin-bottom: 2em">
            <div>
              <input formControlName="Last" style="margin-left: 5px; border-radius: inherit" />
            </div>
            <div>
              <input formControlName="First" style="margin-left: 5px; border-radius: inherit" />
            </div>
            <div>
              <input formControlName="ID" style="margin-left: 5px; border-radius: inherit" />
            </div>
            <div>
              <input
                formControlName="Phone"
                style="margin-left: 5px; border-radius: inherit; width: 100px"
              />
            </div>
          </div>
          <div>
            <span>
              <strong style="margin-left: 1em">
                אני מצהירה ומאשרת בזאת שקיבלתי הסבר מפורט ובעל פה מ
              </strong>
              <input
                formControlName="refferalDoc"
                class="l-textarea t-field--limitRad h100"
                style="margin-left: 5px; border-radius: 0.75em"
              />
            </span>
          </div>
          <div style="display: grid">
            <span>
              <strong>
                על הצורך בביצוע הפעולה העיקרית בדיקת אולטרה סאונד עוברי --
                {{
                  (concentForm.get('ExamType').value
                    ? 'exam.type.OBS.' + concentForm.get('ExamType').value
                    : ''
                  ) | translate
                }}
              </strong>
            </span>
            <div class="login-form-row">
              <div
                class="login-form-row"
                style="background-color: #e4eded; margin: 5px; border-radius: 0.75em; width: 70%"
              >
                <span>
                  {{ concentForm.get('CreationTime').value | date: 'HH:mm dd/MM/yyyy' }}
                </span>
              </div>
            </div>
          </div>
          <div style="display: grid; place-self: center">
            <span>חתימת המטופלת\אפוטרופוס</span>
            <img
              *ngIf="concentForm.get('patSign').value"
              [src]="concentForm.get('patSign').value"
              style="width:500px; height:200px; border:1px solid black; display:block;"
            />
            <div
              *ngIf="!concentForm.get('patSign').value"
              style="width:500px; height:200px; border:1px solid black;"
            ></div>
          </div>
          <hr class="r-concent" />
          <ng-container
            *ngIf="
              concentForm.get('ExamType').value !== 'NT' &&
              concentForm.get('ExamType').value !== 'Third Scan'
            "
          >
            <div class="r-concent">
              1.הובהר לי כי בדיקת האולטרה סאונד העוברי הינה (סמן את הבדיקה שתבוצע):
              <div>
                <span>
                  {{ 'exam.type.OBS.' + concentForm.get('ExamType').value | translate }}
                </span>

                <span> בשבוע </span>
                <input
                  formControlName="weekNum"
                  class="w50 l-textarea t-field--limitRad h100"
                  style="margin-left: 5px; border-radius: 0.75em; place-self: center"
                />
              </div>
            </div>
            <div class="r-concent">
              2. הבדיקה נעשית ביוזמת
              <div
                class="l-flex-c l-flex-w indicative-fieldset h100"
                style="justify-content: space-evenly"
              >
                <label class="t-label-top">
                  <input
                    type="radio"
                    formControlName="preformed"
                    value="women"
                    class="custom-check -sq"
                  />
                  <i class="customInput-display -sq" style="margin-left: 0.31em"></i>
                  <span> הנבדקת </span>
                </label>
                <label class="t-label-top">
                  <input
                    type="radio"
                    formControlName="preformed"
                    value="doctor"
                    class="custom-check -sq"
                  />
                  <i class="customInput-display -sq" style="margin-left: 0.31em"></i>
                  <span> על פי הפנית רופא </span>
                </label>
              </div>
              <div style="display: grid">
                <span *ngIf="concentForm.get('preformed').value === 'doctor'">סיבת הפניה</span>
                <textarea
                  *ngIf="concentForm.get('preformed').value === 'doctor'"
                  class="scroller fulltext"
                  formControlName="docReason"
                ></textarea>
                <span> בהעדר פרוט הסיבה להפניה, ההתייחסות בבדיקה הינה להריון בסיכון נמוך. </span>
              </div>
            </div>
            <div class="r-concent">3. הנתונים שיבדקו הם אלה שיודגמו ויסומנו בטופס הבדיקה.</div>
            <div class="r-concent">
              4. ידוע לי שבדיקת האולטרה סאונד הינה מוגבלת ואינה יכולה או מתיימרת לאתר את כל המומים /
              הפגמים האפשריים בעובר, בכל מקרה ובכל הריון, גם לא את כל המומים באברים שנבדקו.
            </div>
            <div class="r-concent">
              5. ידוע לי שישנם מומים / ליקויים אשר לא ניתנים לאבחון מוחלט בבדיקת אולטרה סאונד (כגון:
              תסמונת דאון, מחלות גנטיות, מחלות זיהומיות ועוד).
            </div>
            <div class="r-concent">
              6. ידוע לי שמידת הדיוק ויכולת האיתור של מומים או פגמים תלויים באופי הממצא וגודלו
              (כגון: פגמים באצבעות), וכן בגיל ההיריון, מיקום העובר, תנוחתו, תנועותיו ומידת העבירות
              של גלי הקול (דופן הבטן).
            </div>
            <div class="r-concent">
              7. ידוע לי שתוצאות הבדיקה משקפות, במגבלות הקיימות, את המצב בזמן הבדיקה וכי ישנם מומים
              העלולים להתפתח או להתגלות רק בהמשך ההיריון (כגון: הפרעות גדילה, סוגי גמדות, מומי לב,
              מוח ועוד).
            </div>
            <div class="r-concent">
              8. ידוע לי כי בבדיקה בה נצפה ממצא חריג יהיה צורך, ע"פ החלטת הרופא המטפל, לבצע בדיקות
              נוספות (כגון: אקו לב-עובר, MRI, יעוץ גנטי, דיקור מי שפיר ויעוץ רופא מומחה בתחום ועוד).
            </div>
            <div class="r-concent">
              9. ידוע לי שסקירת מערכות מוקדמת המבוצעת בשבועות 13-17, איננה מחליפה את הסקירה המאוחרת
              אותה מומלץ לבצע בשבועות 19-25, מכיוון שחלק מהמומים שניתן לאבחן בסקירה המאוחרת, אינם
              מתבטאים בסקירה המוקדמת.
            </div>
            <div class="r-concent">
              10. ניתן יהיה לבצע בדיקות נוספות גם בהעדר ממצאים, על פי רצוני ועל חשבוני.
            </div>
          </ng-container>
          <ng-container *ngIf="concentForm.get('ExamType').value === 'Third Scan'">
            <div class="r-concent">
              1.הובהר לי כי בדיקת האולטרה סאונד העוברי הינה (סמן את הבדיקה שתבוצע):
              <div>
                <span>{{ 'exam.type.OBS.' + concentForm.get('ExamType').value | translate }} </span>

                <span> בשבוע </span>
                <input
                  formControlName="weekNum"
                  class="w50 l-textarea t-field--limitRad h100"
                  style="margin-left: 5px; border-radius: 0.75em; place-self: center"
                />
              </div>
            </div>
            <div class="r-concent">
              2. הבדיקה נעשית ביוזמת
              <div
                class="l-flex-c l-flex-w indicative-fieldset h100"
                style="justify-content: space-evenly"
              >
                <label class="t-label-top">
                  <input
                    type="radio"
                    formControlName="preformed"
                    value="women"
                    class="custom-check -sq"
                  />
                  <i class="customInput-display -sq" style="margin-left: 0.31em"></i>
                  <span> הנבדקת </span>
                </label>
                <label class="t-label-top">
                  <input
                    type="radio"
                    formControlName="preformed"
                    value="doctor"
                    class="custom-check -sq"
                  />
                  <i class="customInput-display -sq" style="margin-left: 0.31em"></i>
                  <span> על פי הפנית רופא </span>
                </label>
              </div>
              <div style="display: grid">
                <span *ngIf="concentForm.get('preformed').value === 'doctor'">סיבת הפניה</span>
                <textarea
                  *ngIf="concentForm.get('preformed').value === 'doctor'"
                  class="scroller fulltext"
                  formControlName="docReason"
                ></textarea>
                <span>בהעדר פרוט הסיבה להפניה, ההתייחסות בבדיקה הינה להריון בסיכון נמוך.</span>
              </div>
            </div>
            <div class="r-concent">
              3. ידוע לי שבדיקת האולטרה סאונד הינה מוגבלת ואינה יכולה או מתיימרת לאתר את כל המומים /
              הפגמים האפשריים בעובר, בכל מקרה ובכל היריון, גם לא את כל המומים באברים שנבדקו.
            </div>
            <div class="r-concent">
              4. ידוע לי שישנם מומים / ליקויים אשר לא ניתנים לאבחון מוחלט בבדיקת אולטרה סאונד (כגון:
              תסמונת דאון, מחלות גנטיות, מחלות זיהומיות ועוד).
            </div>
            <div class="r-concent">
              5. ידוע לי שמידת הדיוק ויכולת האיתור של מומים או פגמים תלויים באופי הממצא וגודלו
              (כגון: פגמים באצבעות), וכן בגיל ההיריון, מיקום העובר, תנוחתו, תנועותיו ומידת העבירות
              של גלי הקול (דופן הבטן).
            </div>
            <div class="r-concent">
              6. ידוע לי שתוצאות הבדיקה משקפות, במגבלות הקיימות, את המצב בזמן הבדיקה וכי ישנם מומים
              העלולים להתפתח או להתגלות רק בהמשך ההיריון.
            </div>
            <div class="r-concent">
              7. ידוע לי שבמצב של עודף משקל ( BMI 30ומעלה) שיעור זיהוי המומים נמוך יותר.
            </div>
            <div class="r-concent">
              8. ידוע לי כי בבדיקה בה נצפה ממצא חריג יהיה צורך, ע"פ החלטת הרופא המטפל, לבצע בדיקות
              נוספות (כגון: אקו לב-עובר, MRI, יעוץ גנטי, דיקור מי שפיר ויעוץ רופא מומחה בתחום ועוד).
            </div>
            <div class="r-concent">
              9. ידוע לי שאין בדיקה זו מהווה סקירה מלאה וכי בדיקת אולטרה-סאונד בשליש השלישי מוגבלת
              מאד ביכולת דימות אברי העובר. מגבלות אלו מונעות אפשרות לסקירה נאותה ולהדגמה של כל
              האיברים האמורים להיבדק בסקירת המערכות הרגילה המבוצעת בשליש השני להריון.
            </div>
            <div class="r-concent">
              10. ניתן יהיה לבצע בדיקות נוספות גם בהעדר ממצאים, על פי רצוני ועל חשבוני.
            </div>
          </ng-container>

          <div
            *ngIf="concentForm.get('ExamType').value !== 'NT'"
            [ngStyle]="
              concentForm.get('ExamType').value === 'NT'
                ? { 'font-size': '16px', 'margin-top': '10px' }
                : {}
            "
            class="r-concent"
          >
            <strong>
              הובהר לי כי בכל מקרה עלי להציג את תוצאות הבדיקה בפני רופא הנשים המטפל. לתשומת לבך:
              בדיקות במסגרות ציבוריות מבוצעות בהתאם ל"סל שירותי הבריאות". לאחר שכל האמור לעיל הובן
              על ידי, הנני מסכימה לביצוע הבדיקה במגבלות האמורות לעיל.
            </strong>
          </div>
          <div class="r-concent">
            <strong>אני נותנת בזאת את הסכמתי לביצוע הפעולה העיקרית.</strong>
          </div>
          <div style="display: grid; margin-bottom: 1em">
            <div
              class="login-form-row"
              style="background-color: #e4eded; margin: 5px; border-radius: 0.75em; width: 70%"
            >
              <span>
                {{ concentForm.get('CreationTime').value | date: 'HH:mm dd/MM/yyyy' }}
              </span>
            </div>
          </div>

          <div
            [ngClass]="concentForm.get('approved').value === 'paitent' ? '' : 'hidden'"
            style="display: grid; place-self: center"
          >
            <span>חתימת הנבדקת\אפוטרופוס</span>
            <img
              *ngIf="concentForm.get('patSignApproved').value"
              [src]="concentForm.get('patSignApproved').value"
              style="width:500px; height:200px; border:1px solid black; display:block;"
            />
            <div
              *ngIf="!concentForm.get('patSignApproved').value"
              style="width:500px; height:200px; border:1px solid black;"
            ></div>
          </div>
          <div
            *ngIf="concentForm.get('ExamType').value === 'NT'"
            style="padding: 3em; height: 40px"
          ></div>
          <div
            *ngIf="concentForm.get('ExamType').value === 'NT'"
            style="padding: 4em; height: 40px"
          ></div>
          <div class="r-concent">
            <span>אני מאשר כי הסברתי בעל פה</span>
            <div
              class="l-flex-c l-flex-w indicative-fieldset h100"
              style="justify-content: space-evenly"
            >
              <label class="t-label-top">
                <input
                  type="radio"
                  formControlName="approved"
                  value="paitent"
                  class="custom-check -sq"
                />
                <i class="customInput-display -sq" style="margin-left: 0.31em"></i>
                <span> למטופלת </span>
              </label>
              <label class="t-label-top">
                <input
                  type="radio"
                  formControlName="approved"
                  value="appotropus"
                  class="custom-check -sq"
                />
                <i class="customInput-display -sq" style="margin-left: 0.31em"></i>
                <span> לאפוטרופוס </span>
              </label>
              <label class="t-label-top">
                <input
                  type="checkbox"
                  name="placenta_TEMP_name"
                  class="custom-check -sq"
                  formControlName="translated"
                  [value]="1"
                />
                <i class="customInput-display"></i>
                <span> למתרגם של המטופלת </span>
              </label>
              <div *ngIf="concentForm.get('translated').value == 1">
                <div
                  class="login-form-row"
                  style="
                    background-color: #e4eded;
                    margin: 5px;
                    border-radius: 0.75em;
                    height: fit-content;
                  "
                >
                  <input
                    formControlName="transName"
                    class="l-textarea t-field--limitRad"
                    style="margin-left: 5px; border-radius: inherit"
                  />
                </div>
                <div
                  class="login-form-row"
                  style="
                    background-color: #e4eded;
                    margin: 5px;
                    border-radius: 0.75em;
                    height: fit-content;
                  "
                >
                  <input
                    formControlName="transRel"
                    class="l-textarea t-field--limitRad"
                    style="margin-left: 5px; border-radius: inherit"
                  />
                </div>
              </div>
            </div>
            <div
              *ngIf="concentForm.get('ExamType').value !== 'NT'"
              style="padding: 2em; height: 10px"
            ></div>
            <div
              [ngStyle]="concentForm.get('ExamType').value !== 'NT' ? { 'margin-top': '70px' } : {}"
            >
              את כל האמור לעיל בפירוט הדרוש וכי הוא/היא חתם/ה על הסכמה בפני לאחר ששוכנעתי כי הבין/ה
              את הסבריי במלואם.
            </div>
            <div *ngIf="concentForm.get('approved').value === 'appotropus'">
              <div style="display: flex">
                <div
                  class="login-form-row"
                  style="
                    background-color: #e4eded;
                    margin: 5px;
                    border-radius: 0.75em;
                    height: fit-content;
                  "
                >
                  <input
                    formControlName="appName"
                    class="l-textarea t-field--limitRad"
                    style="margin-left: 5px; border-radius: inherit"
                  />
                </div>
                <div
                  class="login-form-row"
                  style="
                    background-color: #e4eded;
                    margin: 5px;
                    border-radius: 0.75em;
                    height: fit-content;
                  "
                >
                  <input
                    formControlName="appRel"
                    class="l-textarea t-field--limitRad"
                    style="margin-left: 5px; border-radius: inherit"
                  />
                </div>
              </div>
              <div style="display: grid; place-self: center">
                <span>חתימת אפוטרופוס</span>
                <img
                  *ngIf="concentForm.get('appSign').value"
                  [src]="concentForm.get('appSign').value"
                  style="width:500px; height:200px; border:1px solid black; display:block;"
                />
                <div
                  *ngIf="!concentForm.get('appSign').value"
                  style="width:500px; height:200px; border:1px solid black;"
                ></div>
              </div>
            </div>
            <div style="display: flex; margin-top: 2em">
              <div
                class="login-form-row"
                style="background-color: #e4eded; margin: 5px; border-radius: 0.75em; width: 30%;  display: flex; align-items: center; justify-content: center;"
              >
                <input
                  formControlName="refferalDoc"
                  class=" center-val"
                  style="margin-left: 5px; border-radius: inherit; border: none;"
                />
              </div>
              <!-- ======= Doctor Credentials (Start) ======= -->
              <div class="doc-credentials login-form-row">
                @if (concentForm.get('DrNum')?.value) {
                  <span>מ.ר. <strong>{{ concentForm.get('DrNum')?.value }}</strong></span>
                }
                @if (concentForm.get('ExpertNum')?.value) {
                  <span>מ.ר.מ. <strong>{{ concentForm.get('ExpertNum')?.value }}</strong></span>
                }
                @if (concentForm.get('NurseNum')?.value) {
                  <span>מ.ר. <strong>{{ concentForm.get('NurseNum')?.value }}</strong></span>
                }
                @if (concentForm.get('TechNum')?.value) {
                  <span>מ.ר. <strong>{{ concentForm.get('TechNum')?.value }}</strong></span>
                }
              </div>
              <!-- ======= Doctor Credentials (End) ======= -->
              <div
                class="login-form-row center-val"
                style="background-color: #e4eded; margin: 5px; border-radius: 0.75em; width: 30%"
              >
                <span>
                  {{ concentForm.get('CreationTime').value | date: 'HH:mm dd/MM/yyyy' }}
                </span>
              </div>
            </div>
            <div style="display: grid; place-self: center">
              <span>חתימת הרופא</span>
              <img
                *ngIf="concentForm.get('docSign').value"
                [src]="concentForm.get('docSign').value"
                style="width:500px; height:200px; border:1px solid black; display:block;"
              />
              <div
                *ngIf="!concentForm.get('docSign').value"
                style="width:500px; height:200px; border:1px solid black;"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  <!-- the PDF renderer waits for .finished before capturing the page -->
  @if (loaded) {
    <span class="finished"></span>
  }
  </div>
</div>
